export default __webpack_public_path__ + "static/media/aircall_ln.c224f6ae.svg";